import React, { Component, Suspense } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { RemoveTrailingSlash } from 'src/components/RemoveTrailingSlash'
import './scss/style.scss'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/pages/login/Login'))
const Register = React.lazy(() => import('./views/pages/register/Register'))
const Page404 = React.lazy(() => import('./views/pages/page404/Page404'))
const Page500 = React.lazy(() => import('./views/pages/page500/Page500'))
const ForgotPassword = React.lazy(() => import('./views/pages/forgotpassword/ForgotPassword'))
const ResetPassword = React.lazy(() => import('./views/pages/resetpassword/ResetPassword'))
const VerifyAccount = React.lazy(() => import('./views/pages/verifyaccount/VerifyAccount'))

class App extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isLoggedIn: false,
    }
  }

  componentDidMount() {
    const authToken = localStorage.getItem('accessToken')
    if (authToken) {
      this.setState({ isLoggedIn: true })
    }
  }

  render() {
    const { isLoggedIn } = this.state
    return (
      <BrowserRouter>
        <Suspense fallback={loading}>
          <RemoveTrailingSlash />
          <Routes>
            <Route exact path="/login" name="Login Page" element={<Login />} />
            <Route
              exact
              path="/reset_password/:code"
              name="Login Page"
              element={<ResetPassword />}
            />
            <Route
              exact
              path="/forgot_password"
              name="Forgot Password"
              element={<ForgotPassword />}
            />
            <Route
              exact
              path="/verify_account/:code/:page"
              name="Verify Account"
              element={<VerifyAccount />}
            />
            <Route exact path="/register" name="Register Page" element={<Register />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route exact path="/500" name="Page 500" element={<Page500 />} />
            <Route path="*" name="Home" element={<DefaultLayout isLoggedIn={isLoggedIn} />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    )
  }
}

export default App
